module.exports = __webpack_public_path__ + "img/logo-blue.44825696.png";